import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Assets
import cloudsBg from "../assets/images/clouds-bg.png";
import pinkClouds from "../assets/images/pink-clouds-divider.png";
import redProdInfo from "../assets/images/red-prod-info.png";
import blueProdInfo from "../assets/images/blue-prod-info.png";
import blueGreenProdInfo from "../assets/images/blue-green-prod-info.png";
import yellowProdInfo from "../assets/images/yellow-prod-info.png";

gsap.registerPlugin(ScrollTrigger);

// Helper to blend colors


export default function ProductStory() {
  const scrollContainer = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  // --- GSAP ScrollTrigger setup ---
useEffect(() => {
  const panels = gsap.utils.toArray("#horizontal .panel");

  gsap.to(panels, {
    xPercent: -100 * (panels.length - 1),
    ease: "none",
    scrollTrigger: {
      trigger: "#horizontal",
      pin: true,
      scrub: 1,
      end: "+=" + window.innerWidth * (panels.length - 1), // make sure scroll distance matches width
    },
  });

  return () => {
    ScrollTrigger.getAll().forEach((t) => t.kill()); // cleanup
  };
}, []);

useEffect(() => {
  // First: set the base background when the section pins
  gsap.to("#horizontal", {
    backgroundColor: "#e5686e",
    scrollTrigger: {
      trigger: "#horizontal",
      start: "top bottom ", // when section hits top
      end: "+=1",       // basically instant
      scrub: true,
    }
  });

  // Second: animate through the rest of the colors as we scroll
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: "#horizontal",
      start: "top top", 
      end: "+=" + window.innerWidth * 3, // remaining 3 color changes
      scrub: true,
    }
  });

  tl.to("#horizontal", { backgroundColor: "#1a7ab5ff", duration: 1.5 })
    .to("#horizontal", { backgroundColor: "#72cec9", duration: 1.5 })
    .to("#horizontal", { backgroundColor: "#f5d35a", duration: 1.5 });
}, []);



  // --- Products per section ---
  const redProducts = [{ src: redProdInfo, alt: "Red Product Info" }];
  const blueProducts = [{ src: blueProdInfo, alt: "Blue Product Info" }];
  const blueGreenProducts = [{ src: blueGreenProdInfo, alt: "Blue Green Product Info" }];
  const yellowProducts = [{ src: yellowProdInfo, alt: "Yellow Product Info" }];

  const [rainingProducts, setRainingProducts] = useState([]);



  // --- Section-based product rain ---
  const [currentSection, setCurrentSection] = useState("red");
  useEffect(() => {
  const sections = [
    { color: "red", trigger: ".red-product-panel" },
    { color: "blue", trigger: ".blue-product-panel" },
    { color: "blueGreen", trigger: ".blue-green-product-panel" },
    { color: "yellow", trigger: ".yellow-product-panel" },
  ];

  sections.forEach((section) => {
    const panel = gsap.utils.toArray("#horizontal .panel");
    ScrollTrigger.create({
      trigger: section.trigger,
      start: "top top", // when that panel hits center of screen
      end: "+=" + window.innerWidth * (panel.length -1),
      scrub: true,
      onUpdate: (self) => {
        const progress = self.progress;
        if (progress < 0.25) setCurrentSection("red");
        else if (progress < 0.5) setCurrentSection("blue");
        else if (progress < 0.75) setCurrentSection("blueGreen");
        else setCurrentSection("yellow");
      }
      
    });
  });

  return () => {
    ScrollTrigger.getAll().forEach((t) => t.kill());
  };
}, []);


  useEffect(() => {
    const productInterval = setInterval(() => {
      let pool = [];
      if (currentSection === "red") pool = redProducts;
      else if (currentSection === "blue") pool = blueProducts;
      else if (currentSection === "blueGreen") pool = blueGreenProducts;
      else pool = yellowProducts;

      const batchSize = 2;
      const newProducts = Array.from({ length: batchSize }).map(() => {
        const base = pool[Math.floor(Math.random() * pool.length)];
        return {
          ...base,
          id: Date.now() + "-" + Math.random(),
          x: `${Math.random() * 95}vw`,
          duration: 5 + Math.random() * 10,
          size: 0.5 + Math.random() * 1.5,
        };
      });

      setRainingProducts((prev) => {
        const capped = [...prev, ...newProducts];
        return capped.length > 40 ? capped.slice(capped.length - 40) : capped;
      });
    }, 600);

    return () => clearInterval(productInterval);
  }, [currentSection]);

  return (
    <div className="products-outer" id="horizontal">
              {/* Top & Bottom cloud strips */}
    
  
        
        
        {/* Horizontal scroll panels (GSAP controlled) */}

        <div className="panel red-product-panel" >
          <Link to="/products#sr-anchor" style={{ textDecoration: "none" }}>
            <h2 className="prod-text-red">STRAWBERRY RUNTS</h2>
          </Link>
        </div>
        <div className="panel blue-product-panel">
          <Link to="/products#zk-anchor" style={{ textDecoration: "none" }}>
            <h2 className="prod-text-blue">ZKITTLEZ</h2>
          </Link>
        </div>
        <div className="panel blue-green-product-panel">
          <Link to="/products#bp-anchor" style={{ textDecoration: "none" }}>
            <h2 className="prod-text-blue-green">BLOWPOPZ</h2>
          </Link>
        </div>
        <div className="panel yellow-product-panel">
          <Link to="/products#lcg-anchor" style={{ textDecoration: "none" }}>
            <h2 className="prod-text-yellow">LEMON CHERRY GELATO</h2>
          </Link>
        </div>
        {/* Raining products */}
    <div className="raining-layer">
      {rainingProducts.map((prod) => (
        <img
          key={prod.id}
          src={prod.src}
          alt={prod.alt}
          style={{
            position: "absolute",
            top: 0,
            left: prod.x,
            transform: `scale(${prod.size})`,
            width: `${prod.size}vw`,
            maxWidth: "120px",
            animation: `fall ${prod.duration}s linear forwards`,
          }}
        />
      ))}
    </div>
        
        
      
      
    </div>
  );
}
